module.exports = __webpack_public_path__ + "img/B808.4e03a5c6.jpg";